var exports = {
  "D": "xdde3148b--fa06f9--carousel",
};

module.exports = exports;
